import {Injectable} from '@angular/core';
import { Observable, of } from 'rxjs';
import {server} from './global.service';
import {server_ip} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

var header={
  Accept: "application/json",
  "Content-Type": "application/json",
}


@Injectable({
  providedIn: 'root'
})


export class organisation_service {
  constructor(private backend: server,public http: HttpClient) { }

  get_all_organisation(page,size,filter):Observable<any>{
    //return this.http.get('./assets/mock/list_of_ext_org.json')
    return this.backend.get(server_ip+"/listOfOrganisation?page="+page+"&size="+size+"&filter="+filter);
   }

   
   getPendingRejectedorganisation(page,size,filter,status):Observable<any>{
    return this.backend.get(server_ip + "/get_approval?page="+page+"&size="+size+"&filter="+filter+"&approvalStatus="+status);
}


   get_oragnisation_by_id(data):Observable<any>{
    return this.backend.post(server_ip+"/view_organisation_by_id",data,header)
   }

   create_organisation(data):Observable<any>{
     return this.backend.post(server_ip+"/add_organisation",data,header)
   }

   editOrganisation(data):Observable<any>{
    return this.backend.post(server_ip+"/updateOrganisation",data,header);
   }
   
   get_suf(data):Observable<any>{
      return this.backend.post(server_ip+"/get_suf",data,header)
   }

   getServicelist():Observable<any>{
    return this.backend.get(server_ip+"/services");
  }

  getOrgListByService(services):Observable<any>{
    return this.backend.get(server_ip+"/getOrgListByService?service="+services);
  }

  getOrganisationLevelServices():Observable<any>{
    return this.backend.get(server_ip+"/org-level-services");
  }

  getCustomersIds():Observable<any>{
    return this.backend.get(server_ip+'/listOfUserForApiBanking');
  }

  createPasswordRequest(data):Observable<any> {
    return this.backend.post(server_ip+"/CreateApiBankUserPassRequest",data,header);
  }

  getRequestsByStatus(status,pageNo,pageSize,filterQuery):Observable<any> {
    return this.backend.get(server_ip+'/list_of_api_banking_users?approvalStatus='+status+'&page='+pageNo+'&size='+pageSize+'&filter='+filterQuery);
  }

  approveOrRejectApiBankingUser(id,approvalStatus,reason):Observable<any> {
    return this.backend.post(server_ip+'/UpdateApproveRejectRequest?id='+id+'&approvalStatus='+approvalStatus+'&reason='+reason,null,null);
  }

  getInfoByCustomerId(id):Observable<any> {
    return this.backend.post(server_ip+'/getEmailPhone?id='+id,null,null);
  }
}
